export const NAV_CATEGORIES = [
  'print-sets',
  'cards',
  'wall-art',
  'desk',
  'photo-books',
  'calendars',
  'display',
  'gifts',
];

export const SHOP_CATEGORIES = [
  'print-sets',
  'cards',
  'wall-art',
  'photo-books',
  'calendars',
  'display',
  'gifts',
];

export const FAVORITE_PRODUCTS = [
  'square-prints',
  'engineer-prints',
  'softcover-books',
  'classic-prints',
  'wall-calendar',
  'artprint',
];

export const FAVORITE_CATEGORIES = ['photo-books', 'display', 'print-sets', 'wall-art'];

// Homepage "New arrivals", rendered in this order. Product ids or product-group category ids
// (e.g. holiday cards), see docs/homepage.md.
export const NEW_PRODUCTS = [
  'custom-photo-holiday-cards',
  // 'custom-photo-greeting-cards',
  'glossy-prints',
  'acrylic-prints',
  // 'metal-wall-prints',
];

export const MIGHT_LIKE_PRODUCTS = [
  'metal-desk-prints',
  'metal-wall-prints',
  'square-prints',
  'engineer-prints',
  'artprint',
  'softcover-books',
  'classic-prints',
  'news-print',
  'framed-prints',
  'square-engineer-prints',
  'wall-calendar-large',
  'engineer-print-calendar',
];
